<template>
  <div class="card-content">
    <form @submit.prevent="buscar">
      <!-- Filtros principais -->
      <div class="columns is-multiline is-variable is-2">
        <div class="column is-full-mobile is-one-quarter-desktop">
          <b-field label="Nome">
            <b-input
              v-model="filtro.nome"
              placeholder="Digite o Nome"
              @input="atualizarBusca"
            />
          </b-field>
        </div>

        <div class="column is-full-mobile is-one-quarter-desktop">
          <b-field label="Documento">
            <b-input
              v-model="filtro.documento"
              placeholder="Digite o CPF ou Passaporte"
              @input="atualizarBusca"
            />
          </b-field>
        </div>

        <div class="column is-full-mobile is-one-quarter-desktop">
          <b-field label="Empresa">
            <b-input
              v-model="filtro.nomeEmpresa"
              placeholder="Nome da Empresa"
              @input="atualizarBusca"
            />
          </b-field>
        </div>

        <div class="column is-full-mobile is-one-quarter-desktop">
          <b-field label="Status">
            <b-select
              v-model="filtro.status"
              placeholder="Status"
              expanded
              @input="atualizarBusca"
            >
              <option :value="null">Todos</option>
              <option value="ATIVO">ATIVO</option>
              <option value="INATIVO">INATIVO</option>
              <option value="PENDENTE">PENDENTE</option>
              <option value="RECUSADO">RECUSADO</option>
              <option value="DOCUMENTACAO_EXPIRADA">DOCUMENTAÇÃO EXPIRADA</option>
              <option value="PENDENTE_BIOMETRIA">PENDENTE BIOMETRIA</option>
            </b-select>
          </b-field>
        </div>
      </div>

      <!-- Filtros Avançados -->
      <b-collapse :open.sync="filtrosAvancadosVisiveis" class="mb-4">
        <div class="columns is-multiline is-variable is-2">
          <div class="column is-full-mobile is-one-third-desktop">
            <b-field label="Tipo">
              <b-select
                v-model="filtro.tipo"
                placeholder="Tipo"
                expanded
                @input="atualizarBusca"
              >
                <option :value="null">Todos</option>
                <option v-for="(item, index) in tipo" :key="index" :value="item.value">
                  {{ item.label }}
                </option>
              </b-select>
            </b-field>
          </div>

          <div class="column is-full-mobile is-one-third-desktop">
            <b-field label="Área">
              <b-select
                v-model="filtro.area"
                placeholder="Área"
                expanded
                @input="tratarFiltroDeArea"
              >
                <option :value="null">Todas</option>
                <option value="PRIMARIA">Primária</option>
                <option value="SECUNDARIA">Secundária</option>
                <option value="ALL">Ambas</option>
              </b-select>
            </b-field>
          </div>
        </div>
      </b-collapse>

      <!-- Botões -->
      <div class="is-flex is-justify-content-space-between is-align-items-center mt-2">
        <b-button
          @click="filtrosAvancadosVisiveis = !filtrosAvancadosVisiveis"
          type="is-text"
          size="is-small"
        >
          {{ filtrosAvancadosVisiveis ? "Ocultar filtros avançados" : "Mostrar filtros avançados" }}
        </b-button>
      </div>
    </form>
  </div>
</template>


<script>
export default {
  name: "FilterAcessoPessoa",
  props: {
    initialFiltro: {
      type: Object,
      default: () => ({
        nome: null,
        documento: null,
        tipo: null,
        nomeEmpresa: null,
        area: null,
        status: null,
        areaPrimaria: null,
        areaSecundaria: null,
      }),
    },
  },
  data() {
    return {
      tipo: [
        { label: "Funcionário", value: "FUNCIONARIO" },
        { label: "Visitante", value: "VISITANTE" },
      ],
      filtro: { ...this.initialFiltro },
      filtrosAvancadosVisiveis: false,
      timer: null,
    };
  },
  methods: {
    atualizarBusca() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.buscar(), 500);
    },
    buscar() {
      this.$emit("filtrar", this.filtro);
    },
    tratarFiltroDeArea() {
      const area = this.filtro.area;
      if (area === "PRIMARIA") {
        this.filtro.areaPrimaria = true;
        this.filtro.areaSecundaria = false;
      } else if (area === "SECUNDARIA") {
        this.filtro.areaPrimaria = false;
        this.filtro.areaSecundaria = true;
      } else if (area === "ALL") {
        this.filtro.areaPrimaria = true;
        this.filtro.areaSecundaria = true;
      } else {
        this.filtro.areaPrimaria = null;
        this.filtro.areaSecundaria = null;
      }

      this.filtro = {
        ...this.filtro,
        areaPrimaria: this.filtro.areaPrimaria,
        areaSecundaria: this.filtro.areaSecundaria,
      };

      this.$emit("filtrar", this.filtro);
    },
  },
};
</script>
